export const capitalize = (text = '') =>
    text.length > 0 ? text.charAt(0).toUpperCase() + text.substr(1).toLowerCase() : text;
